import React from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import AudioPlayer from "react-modular-audio-player";
import { Row, Card, message, Modal, Input, Alert, Spin } from "antd";
import profilePic from "../../../../black.jpg";
import "../profile.css";
import TagsInput from "./tagsInput";
import { getAllMedia, uploadRingTone } from "../../../services/upload";
import { createCategory, getCategories } from "../../../services/categories";
import { serverDomain } from "../../../config";
import { logout } from "../../../store/loginAction";
import playIcon from "../../../../playIcon.png";
import pauseIcon from "../../../../pauseIcon.png";

const rearrangedPlayer = [
  {
    className: "adele",
    innerComponents: [
      {
        type: "play",
        style: {
          width: "100%",
          justifyContent: "center",
          opacity: "1"
        }
      }
    ]
  }
];

class SubProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      tags: [],
      fileInfo: {},
      error: {},
      title: "",
      category: "",
      categoryId: "",
      newCategory: "",
      description: "",
      previewUrl: "",
      selectedMedia: "",
      mediaType: "wallPaper",
      publish: false,
      visible: false,
      hasMoreItems: true,
      loading: false
    };
  }

  async componentWillMount() {
    const categories = await getCategories();
    // this.onGetMediaList(this.state.mediaType)
    this.setState({
      categories
    });
  }

  onChange = e => {
    let { categoryId, categories } = this.state;
    const { name, value, type, checked } = e.target;
    if (name === "category") {
      const object = categories && categories.find(c => c.name === value);
      categoryId = object && object._id;
    }
    this.setState({
      [name]: type === "checkbox" ? checked : value,
      categoryId
    });
  };

  selectedTags = tags => {
    this.setState({ tags });
  };

  onCreateCategory = async () => {
    const { newCategory, categories } = this.state;
    if (newCategory) {
      const array = categories.map(c => c.name.toLowerCase()) || [];
      const index = array.indexOf(newCategory.toLowerCase()) === -1;
      if (index) {
        const data = await createCategory({ name: newCategory });
        message.success(`${newCategory} category created successfully.`);
        categories.push(data);
        this.setState({
          visible: false,
          newCategory: "",
          categories
        });
      } else {
        message.error(`${newCategory} category already existing!`);
      }
    } else {
      this.setState({
        visible: false,
        newCategory: "",
        categories
      });
    }
  };

  showModal = async () => {
    this.setState({
      visible: !this.state.visible,
      newCategory: ""
    });
  };

  onHandleDrop = file => {
    const array = ["jpeg", "jpg", "png", "gif"]; //"mp3"
    if (file && file.length) {
      message.config({ duration: 5, maxCount: 3 });
      const name = file[0].name
        .split(".")
        .pop()
        .toLowerCase();
      if (array.indexOf(name) === -1) {
        return message.error(
          <span>
            <div>
              <b>
                <h5>invalid file!!</h5>
              </b>
            </div>
            <div>
              Only &nbsp;
              <b>["jpeg", "jpg", "png", "gif"]</b>&nbsp; valid!
            </div>
          </span>
        );
      }

      if (
        ["jpeg", "jpg", "png", "gif"].indexOf(file[0].name.split(".").pop()) ===
        -1
      ) {
        const reader = new FileReader();
        const url = reader.readAsDataURL(file && file[0]);

        reader.onloadend = function(e) {
          console.log({ url: reader.result });
          this.setState(
            {
              imgSrc: [reader.result] || "",
              fileInfo: (file && file[0]) || {},
              previewUrl: (file && file[0] && file[0].preview) || "",
              selectedMedia: "ringTone"
            },
            () => this.props.getFileList([])
          );
        }.bind(this);
        console.log(url);
      } else {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        const that = this;

        img.onload = function() {
          console.log({ width: this.width, height: this.height });
          if (!(this.width >= 720 && this.height >= 1280)) {
            return message.error(
              <h5>
                Uploaded image does not meet minimum specs of 720 x 1280 pixels.
                <div>Try again with a larger image!!</div>
              </h5>
            );
          }
          that.setState(
            {
              imgSrc: img.src || "",
              fileInfo: (file && file[0]) || {},
              previewUrl: img.src || "",
              selectedMedia: "wallPaper"
            },
            () => that.props.getFileList([])
          );
        };
        img.src = _URL.createObjectURL(file[0]);
      }
    } else {
      this.setState({
        imgSrc: "",
        fileInfo: (file && file[0]) || {},
        previewUrl: "",
        selectedMedia: ""
      });
    }
  };

  onUpload = async () => {
    const { userDetails } = this.props;
    const {
      title,
      fileInfo,
      categoryId,
      description,
      tags,
      selectedMedia,
      error
    } = this.state;
    // if(!title && (tags && tags.length && tags.length < 2) && !categoryId){
    if (!title) {
      error.title = "title is required!";
    } else {
      delete error.title;
    }
    if (tags && tags.length < 2) {
      error.tag = "minimum 2 tags required!";
    } else {
      delete error.tag;
    }
    if (!categoryId) {
      error.category = "please select category!";
    } else {
      delete error.category;
    }
    this.setState({ error });
    // }

    if (Object.keys(error).length) return;

    const formData = new FormData();

    formData.append("image", fileInfo);
    const data = {
      name: userDetails && `${userDetails.firstName} ${userDetails.lastName}`,
      publish: false,
      title: title,
      categoryId: categoryId,
      userId: userDetails && userDetails._id,
      tag: tags,
      description: description,
      mediaType: selectedMedia,
      fileName: fileInfo.name
    };
    this.setState({ loading: true });
    // formData.append("mediaTypeId", "5db042ee7381fd3cf4ab2b42");

    const upload = await uploadRingTone(formData, data);
    if (upload && upload.success) {
      this.setState({ loading: false });
      message.success("Image uploaded successfully!");
      this.setState({
        fileInfo: {},
        publish: false,
        title: "",
        category: "",
        description: "",
        tags: []
      });
    } else {
      this.setState({ loading: false });
      message.error("something went wrong!");
    }
  };

  loadItems = async page => {
    const { fileList, userDetails } = this.props;
    // const type = mediaType === "ringtones" ? "&mediaType=ringTone" : mediaType === "wallpapers" ? "&mediaType=wallPaper" : ""
    const data = await getAllMedia(
      `currentPage=${page}&size=${5}&userId=${userDetails && userDetails._id}`
    );
    if (data && data.done) {
      if (page === 0) {
        data.media.data.unshift({ imagePath: "" });
      }
      if (data && data.done && data.media.data.length) {
        this.props.getFileList(data && data.media && data.media.data);
      }
    }
    if (
      fileList &&
      fileList.length === data &&
      data.media &&
      data.media.metadata &&
      data.media.metadata.total
    ) {
      this.setState({
        hasMoreItems: false
      });
    }
  };

  onRemove = () => {
    this.setState({
      fileInfo: {},
      title: "",
      tags: [],
      categoryId: "",
      category: "",
      description: ""
    });
  };

  render() {
    const { userDetails, fileList } = this.props;
    const {
      categories,
      visible,
      fileInfo,
      newCategory,
      title,
      category,
      description,
      tags,
      imgSrc,
      error,
      hasMoreItems
    } = this.state;
    const styles = {
      width: "100%",
      height: 230,
      border: "2px dashed #ccc",
      padding: 35,
      marginTop: 20,
      background: "#d5c8f4",
      borderRadius: 15
    };
    const loader = <div className="loader">...</div>;
    const items = [];

    if (fileList && fileList.length) {
      (fileList || []).map((media, index) => {
        const type =
          (media && media.imagePath && media.imagePath.split(".").pop()) || "";

        items.push(
          <div
            className="col-md-4 col-sm-6 col-lg-3 col-xl-2"
            key={index.toString()}
            style={{ padding: 5 }}
          >
            <div className="card">
              {index === 0 ? (
                <div>
                  <Dropzone
                    onDrop={this.onHandleDrop}
                    style={{ ...styles, height: 450, marginTop: 0 }}
                  >
                    <div style={{ textAlign: "center", marginTop: "45%" }}>
                      <i
                        className="fas fa-cloud-upload-alt"
                        style={{ fontSize: 70, color: "#5f4483" }}
                      />
                      <h3>Drag and drop</h3>
                      <i
                        className="fas fa-camera"
                        style={{
                          fontSize: 50,
                          marginRight: 30,
                          color: "white"
                        }}
                      />
                      <i
                        className="fas fa-volume-up"
                        style={{ fontSize: 50, color: "white" }}
                      />
                    </div>
                  </Dropzone>
                </div>
              ) : (
                <div>
                  {["jpeg", "jpg", "png", "gif"].indexOf(type) > -1 ? (
                    <div>
                      <img
                        className="card-img-top"
                        src={media.imagePath}
                        alt="preview_image"
                        style={{
                          height: 450,
                          margin: 0,
                          cursor: "pointer",
                          objectFit: "cover"
                        }}
                        onClick={() =>
                          this.setState({ isOpen: true, photoIndex: index })
                        }
                      />
                      <span>
                        <h5 className="img-text">{media.title}</h5>
                      </span>
                    </div>
                  ) : (
                    <div>
                      <div
                        className="audio-background card-img-top"
                        onClick={() =>
                          this.setState({
                            isOpen: true,
                            isRingtone: true,
                            photoIndex: index
                          })
                        }
                      >
                        <div
                          className="audio-div"
                          onClick={e => {
                            e.stopPropagation();
                          }}
                        >
                          <AudioPlayer
                            audioFiles={[
                              {
                                src: `${serverDomain}${media.imagePath}`,
                                title: "Rolling In The Deep",
                                artist: "Adele"
                              }
                            ]}
                            playIcon={playIcon}
                            pauseIcon={pauseIcon}
                            rearrange={rearrangedPlayer}
                            playerWidth="auto"
                            iconSize="9rem"
                          />
                        </div>
                      </div>

                      <span>
                        <h5 className="img-text">{media.title}</h5>
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
        return null;
      });
    }

    return (
      <div style={{ paddingRight: 50, paddingLeft: 50 }}>
        <Spin spinning={!Object.keys(userDetails || {}).length}>
          <Row type="flex" justify="center" align="top">
            <img className="profileImg" src={profilePic} alt="logo" />
            <Card bordered={false}>
              <h2>
                {(userDetails &&
                  userDetails.firstName + " " + userDetails.lastName) ||
                  ""}
              </h2>
              <Link to="/editprofile">
                <i className="fas fa-cog" /> Setting
              </Link>
              <span>&nbsp;&nbsp;&nbsp;</span>
              <Link to="/signin" onClick={this.props.onLogout}>
                <i className="fas fa-sign-out-alt"></i> Logout
              </Link>
            </Card>
          </Row>
        </Spin>

        <hr />

        <section>
          {fileInfo && fileInfo.name ? (
            <div>
              <Alert
                style={{ marginTop: 10 }}
                message={
                  <div>
                    {["jpeg", "jpg", "png", "gif"].indexOf(
                      fileInfo.name.split(".").pop()
                    ) === -1 ? (
                      <figure>
                        <audio controls src={imgSrc}>
                          Your browser does not support the
                          <code>audio</code> element.
                        </audio>
                      </figure>
                    ) : (
                      <img
                        alt="preview_image"
                        src={imgSrc}
                        onClick={() =>
                          window.open(this.state.previewUrl, "_blank")
                        }
                        style={{ width: 150, cursor: "pointer" }}
                      />
                    )}
                    <span className="text-primary" style={{ margin: 25 }}>
                      {fileInfo.name}
                    </span>
                  </div>
                }
                type="info"
                closable
                closeText={
                  <i className="fas fa-trash-alt" onClick={this.onRemove} />
                }
                afterClose={this.onHandleDrop}
              />

              <Spin spinning={this.state.loading} size="large">
                <div className="form-group" style={{ marginTop: "1rem" }}>
                  <label htmlFor="exampleInputEmail1" className="label">
                    What is it called?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={title}
                    placeholder="Title"
                    onChange={this.onChange}
                  />
                  <span className="text-danger">
                    {(error && error.title) || ""}
                  </span>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="label">
                    Tag your upload
                  </label>
                  <TagsInput tags={tags} selectedTags={this.selectedTags} />
                  <span className="text-danger">
                    {(error && error.tag) || ""}
                  </span>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="label">
                    Category
                  </label>
                  <select
                    className="browser-default custom-select"
                    name="category"
                    onChange={this.onChange}
                    value={category}
                  >
                    <option disabled selected>
                      Select a category
                    </option>
                    {categories &&
                      categories.length &&
                      categories.map((drop, index) => (
                        <option value={drop.name} key={index.toString()}>
                          {drop.name}
                        </option>
                      ))}
                  </select>
                  <span className="text-danger">
                    {(error && error.category) || ""}
                  </span>
                  <div
                    style={{ color: "#4288dd", cursor: "pointer" }}
                    onClick={this.showModal}
                  >
                    Create category
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="label">
                    Description
                  </label>
                  <textarea
                    placeholder="Description..."
                    className="form-control"
                    rows="3"
                    name="description"
                    value={description}
                    onChange={this.onChange}
                  />
                </div>

                <div className="row">
                  <div className="col text-center">
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={this.onUpload}
                    >
                      <i className="fas fa-cloud-upload-alt" /> Upload
                    </button>
                  </div>
                </div>
              </Spin>
            </div>
          ) : null}
        </section>

        {userDetails &&
        Object.keys(userDetails).length &&
        !(fileInfo && fileInfo.name) ? (
          <div>
            <InfiniteScroll
              pageStart={-1}
              loadMore={this.loadItems}
              hasMore={hasMoreItems}
              loader={loader}
            >
              <div className="row">{items}</div>
            </InfiniteScroll>
          </div>
        ) : null}

        <Modal
          title="Create New Category"
          okText="Create Category"
          visible={visible}
          onOk={this.onCreateCategory}
          onCancel={this.showModal}
          style={{ height: "70%", width: "90%" }}
        >
          <Input
            placeholder="category"
            type="text"
            name="newCategory"
            onChange={this.onChange}
            value={newCategory}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state && state.loginUser
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(logout())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubProfile);
